// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"_o-z","badgeLink":"ap-z","category":"bp-z"};